module.exports = __webpack_public_path__ + "static/media/potato.9e9d7bae.svg";